module.exports = __webpack_public_path__ + "img/fenrir_logo.dd723b62.svg";